import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({ standalone: false,
  selector: 'app-form-skeleton',
  templateUrl: './form-skeleton.component.html',

  styleUrls: ['./form-skeleton.component.css']
})
export class FormSkeletonComponent {

  @Input() columns: number = 2;
  @Input() count: number = 5;

  getColumnClass(): string {
    return `col-12 md:col-${12 / this.columns}`;
  }

}
